import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, first } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';
import { AccountRouteParams } from '../../core/routeparams';
import { Site, SiteService } from '../../core/site';
import { Account, AccountService } from '../../core/account';

@Component({
  selector: 'app-entry',
  template: ``,
  standalone: false,
})
export class EntryComponent implements OnInit {
  private accountId: string;

  constructor(
    private router: Router,
    private siteService: SiteService,
    private route: ActivatedRoute,
    private accountService: AccountService,
  ) {}

  ngOnInit(): void {
    this.accountId = (this.route.snapshot.params as AccountRouteParams).accountGroupId;
    this.accountService.fetch(this.accountId);

    const siteResult$ = this.siteService.lookup(this.accountId);
    const accountResult$ = this.accountService.result();

    combineLatest([
      siteResult$.pipe(
        catchError(() => {
          const empty: Site = null;
          return of(empty);
        }),
      ),
      accountResult$.pipe(
        catchError(() => {
          const empty: Account = null;
          return of(empty);
        }),
      ),
    ])
      .pipe(first())
      .subscribe(([site, account]) => {
        if (site) {
          this.router.navigateByUrl('/site/' + site.siteId + '/overview');
          return;
        }
        this.router.navigateByUrl('/create-from-template/' + account.accountId);
      });
  }
}
